import {
    createMountsGlazingGasketConfig,
    createMountsMullionsHorizontalConfig,
    createMountsMullionsVerticalConfig,
    createMountsCGFChannelHorizontalConfig,
    createMountsCGFChannelVerticalConfig,
    createMountsCGFFrameHorizontalConfig,
    createMountsCGFFrameVerticalConfig,
} from "../../base";
import { MountsService } from "@/app/services/mounts.service";
import { IComponentConfig } from "@/app/@types/base-component";
import { LineDividerCalculationService } from "@/app/services/line-dividers.service";
import { CGF350Code } from "@/app/constants";
import { Partition } from "@/app/domain/entities/partition";

const createSwingDoorMountsCGFFrameVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFFrameVertical(partition);

    return createMountsCGFFrameVerticalConfig().qty(0).area(length).build();
};

const createSwingDoorMountsCGFFrameHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFFrameHorizontal(partition);

    return createMountsCGFFrameHorizontalConfig().qty(0).area(length).build();
};

const createSwingDoorMountsCGFChannelVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFChannelVertical(partition);

    return createMountsCGFChannelVerticalConfig().qty(0).area(length).build();
};

const createSwingDoorMountsCGFChannelHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const partitionWidth = MountsService.getTotalWidth(partition);
    const cgfFrameHorizontal = MountsService.getCGFFrameHorizontal(partition);

    const length = Math.round(partitionWidth - cgfFrameHorizontal) || 0;

    return createMountsCGFChannelHorizontalConfig().qty(0).area(length).build();
};

const createSlidingDoorMountsMullionsHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const width = MountsService.getTotalWidth(partition);
    const height = MountsService.getTotalHeight(partition);

    // Переделали формулу, в задаче 8698v2rfj: было вот так width * horizontalLinesQty * sides

    const horizontalLinesQty =
        LineDividerCalculationService.calculateHorizontalDividers(
            CGF350Code,
            height,
        );

    const qty = Math.round(width * horizontalLinesQty) || 0;

    return createMountsMullionsHorizontalConfig()
        .qty(horizontalLinesQty)
        .width(width)
        .area(qty)
        .build();
};

const createSlidingDoorMountsMullionsVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const width = MountsService.getTotalWidth(partition);
    const height = MountsService.getTotalHeight(partition);

    // Было 2 стороны, но потом почему-то изменилось на 1 (8698v2rfj)
    const sides = 1;

    const verticalLinesQty =
        LineDividerCalculationService.calculateVerticalDividers(
            CGF350Code,
            width,
        );

    const qty = Math.round(height * verticalLinesQty * sides) || 0;

    return createMountsMullionsVerticalConfig()
        .qty(verticalLinesQty)
        .width(height)
        .area(qty)
        .build();
};

const createSlidingDoorMountsGlazingGasketConfig = (
    partition: Partition,
): IComponentConfig => {
    const totalWidth = MountsService.getTotalWidth(partition);
    const totalHeight = MountsService.getTotalHeight(partition);
    const doorWidth = MountsService.getDoorTotalWidth(partition);
    const hasTransom = MountsService.hasOverdoorTransom(partition);

    const sides = 2;
    const transomMultiplier = hasTransom ? 1 : sides;

    const totalDoorWidth = doorWidth * transomMultiplier;//top and bottom sides
    const horizontalGaskets = totalWidth * sides - totalDoorWidth;//top and bottom sides
    const verticalGaskets = totalHeight * sides;//left and right sides

    const qty = Math.round((horizontalGaskets + verticalGaskets) * sides) || 0; //inner and outer sides

    return createMountsGlazingGasketConfig().qty(0).area(qty).build();
};

export const CGF350SwingDoorsConfigs = (partition: Partition) => [
    createSwingDoorMountsCGFFrameVerticalConfig(partition),
    createSwingDoorMountsCGFFrameHorizontalConfig(partition),
    createSwingDoorMountsCGFChannelVerticalConfig(partition),
    createSwingDoorMountsCGFChannelHorizontalConfig(partition),
    createSlidingDoorMountsMullionsHorizontalConfig(partition),
    createSlidingDoorMountsMullionsVerticalConfig(partition),
    createSlidingDoorMountsGlazingGasketConfig(partition),
];
